import * as yup from "yup";
import moment from "moment";
import fileReaderStream from "filereader-stream";
import concat from "concat-stream";
import MediaHelper from "../../../../common/MediaHelper";
import {MediaEndpoints} from "../../../../common/ProxyEndpoints";
import AppVariables from "../../../../common/AppVariables";
import TTLProxy from "../../../../common/TTLAsyncProxy";

export const MIN_VERIFICATION_USERS = Number(process.env.REACT_APP_MIN_VERIFICATION_USERS || 1);

export const PaymentMediaTags = {
    BankPhoto: "bank-photo",
    DocumentPhoto: "document-photo",
    CreditorPhoto: "creditor-photo",
    SupportPhoto: "support-photo"
};

export const ValidationSchemas = {

    AddUser: yup.object().shape({
        user: yup.mixed().required().label("User"),
        enable_edit: yup.bool().label("Allow Edit"),
        comments: yup.string().notRequired().label("Comments")
    }),

    AddConsumers: yup.object().shape({
        max_amount: yup.number().label("Maximum amount"),
        reference_mode: yup.string().label("Reference mode"),
        phone: yup.string().label("Phone"),
        email: yup.string().label("Email"),
        farmer: yup.mixed().label("Farmer"),
        comments: yup.string().notRequired().label("Comments")
    }),

    AddService: yup.object().shape({
        service: yup.mixed().required().label("Service"),
        comments: yup.string().notRequired().label("Comments")
    })

};


export const generateReference = () => {
    const ALPHABETS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return `CBZ-${[1,2,3,4,5].map(x => ALPHABETS[Math.floor(Math.random() * 26)]).join("")}:${moment().format('DD-MM-YYYY')}`
};

export const uploadProfileImage = (file,entityName, entityId, tag ,compressed = true) => {

    const proxy = TTLProxy.getInstance();

    return new Promise((resolve,reject) => {

        fileReaderStream(file).pipe(concat(async (content) => {

            try {

                if(compressed)
                    content = await MediaHelper.compressImageUploadAsync(content);

                const response = await proxy.processRequest(MediaEndpoints.createMedia(entityName, entityId, file, content, tag || AppVariables.ProfileImageTag));
                if(response.ok){
                    return resolve(true);
                }

            }
            catch (e) {
                return reject(false);
            }

        }))

    });


};

export const excludeColumns = (columns,keys) => {

    if(Array.isArray(keys) && keys.length > 0){
        return columns.filter(x => !keys.includes(x.key));
    }

    return columns;
};



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/CommandAgriculture/Common.js